(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('ItemSelectionModalCtrl', ItemSelectionModalController);

  ItemSelectionModalController.$inject = [
    '$scope',
    'items',
    'itemName',
    'primaryKey',
    'descriptionKey'
  ];

  function ItemSelectionModalController($scope, items, itemName, primaryKey, descriptionKey) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.items = items;
    vm.itemName = itemName;
    vm.primaryKey = primaryKey;
    vm.descriptionKey = descriptionKey;
    vm.selected = [];

    //////////////////////////////////////////
    // Bindable methods
    vm.close = close;
    vm.toggle = toggle;
    vm.save = save;
    vm.filterParam = filterParam;

    //////////////////////////////////////////
    // Function declarations

    function close() {
      $scope.$dismiss();
    }

    function toggle(item) {
      if (vm.allowMultiple) {
        if (vm.selected.includes(item)) {
          return vm.selected.splice(vm.selected.indexOf(item), 1);
        }
        vm.selected.push(item);
      } else {
        vm.selected[0] = item;
      }
    }

    function save() {
      if (vm.allowMultiple) {
        return $scope.$close(vm.selected);
      }
      $scope.$close(vm.selected[0]);
    }

    function filterParam(value) {
      const param = {};
      param[descriptionKey] = value;
      return param;
    }
    //////////////////////////////////////////
    // Controller logic
  }
}());
